var map = {
	"./dts/src/app/work-order/work-order.module": [
		47152,
		"default-projects_dts_src_app_work-order_work-order-edit_work-order-edit_component_ts",
		"projects_dts_src_app_work-order_work-order_module_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5653;
module.exports = webpackAsyncContext;